import apiPg, { PG_OPERATOR_KEY, PG_TOKEN_KEY } from "@utils/api/api_pg";

// 對應後端 AppError::PG_*
export const PgError = {
	LOGIN_FAILED: 1101,
	UNAUTHORIZED: 1102,
	CAMPAIGN_NOT_FOUND: 1103,
	CAMPAIGN_MISCONFIGURED: 1104,
	REDEEM_CLOSED: 1105,
	MEMBER_NOT_BOUND: 1106,
	ALREADY_REDEEMED: 1107,
	COUPON_INVALID: 1108,
	COUPON_EXPIRED: 1109,
	COUPON_NOT_STARTED: 1110,
	SCAN_FAILED: 1111,
};

const ERROR_MESSAGES = {
	[PgError.LOGIN_FAILED]: "帳號或密碼錯誤",
	[PgError.UNAUTHORIZED]: "登入已失效，請重新登入",
	[PgError.CAMPAIGN_NOT_FOUND]: "找不到活動",
	[PgError.CAMPAIGN_MISCONFIGURED]: "活動設定有誤，請聯絡管理員",
	[PgError.REDEEM_CLOSED]: "目前暫停兌換",
	[PgError.MEMBER_NOT_BOUND]: "查無會員或尚未綁定 LINE，請先完成綁定",
	[PgError.ALREADY_REDEEMED]: "此會員已兌換過",
	[PgError.COUPON_INVALID]: "此券已作廢，無法兌換",
	[PgError.COUPON_EXPIRED]: "此券已過期",
	[PgError.COUPON_NOT_STARTED]: "此券尚未開始",
	[PgError.SCAN_FAILED]: "系統異常，請稍後再試",
};

/** 把 axios error 轉成 { code, message, data } 給畫面顯示 */
export const toPgError = (error) => {
	const body = error?.response?.data?.error;
	if (!body) {
		return { code: null, message: "網路異常，請確認連線後再試", data: {} };
	}
	if (error.response.status === 429) {
		return { code: null, message: "操作太頻繁，請稍候再試", data: {} };
	}
	return {
		code: body.code,
		message: ERROR_MESSAGES[body.code] ?? body.message ?? "發生錯誤",
		data: body.data ?? {},
	};
};

export const pgLogin = async (account, password) => {
	const res = await apiPg.post("/pg/login", { account, password });
	localStorage.setItem(PG_TOKEN_KEY, res.access_token);
	localStorage.setItem(PG_OPERATOR_KEY, JSON.stringify(res.operator));
	return res;
};

export const pgLogout = async () => {
	try {
		await apiPg.post("/pg/logout");
	} finally {
		localStorage.removeItem(PG_TOKEN_KEY);
		localStorage.removeItem(PG_OPERATOR_KEY);
	}
};

export const hasPgToken = () => !!localStorage.getItem(PG_TOKEN_KEY);

export const getPgOperator = () => {
	try {
		return JSON.parse(localStorage.getItem(PG_OPERATOR_KEY) ?? "null");
	} catch {
		return null;
	}
};

export const getPgCampaigns = () => apiPg.get("/pg/campaigns");

export const getPgCampaign = (code) => apiPg.get(`/pg/campaigns/${encodeURIComponent(code)}`);

// inputMethod: "camera"（相機掃描）| "keyboard"（輸入框：手動輸入或掃碼槍），後端寫進掃碼紀錄

/** 掃描後查詢（不兌換）：可兌換才跳確認彈窗 */
export const checkPgCampaign = (code, vipCode, inputMethod) =>
	apiPg.post(`/pg/campaigns/${encodeURIComponent(code)}/check`, {
		vip_code: vipCode,
		input_method: inputMethod,
	});

/** 確認兌換 */
export const scanPgCampaign = (code, vipCode, inputMethod) =>
	apiPg.post(`/pg/campaigns/${encodeURIComponent(code)}/scan`, {
		vip_code: vipCode,
		input_method: inputMethod,
	});
